import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { CliAuthPage } from './cli-auth';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [CliAuthPage],
    imports: [PagesModule, ComponentsModule]
})
export class CliAuthPageModule {}
